const volunteers = {
  tab: "Ehrenamtliche MitarbeiterInnen",
  createButton: "Ehrenamtliche/r MitarbeiterIn anlegen",
  noResults: "Keine ehrenamtlichen MitarbeiterInnen vorhanden.",
  moreResults: "Es gibt noch weitere MitarbeiterInnen die aufgrund der Limitierung nicht angezeigt werden",
  searchPlaceholder: "MitarbeiterInnen finden",
  backAria: "Zurück zur Übersicht",
  roleChip: "Ehrenamtliche/r",
  tabs: {
    personalData: "Persönliche Informationen",
    assignedClients: "Zugewiesene Kundenakte",
    access: "Zugang Ehrenamtliche",
  },
  assignedClients: {
    title: "Zugewiesene Kundenakte",
    description: "Kundenakte, die dieser ehrenamtlichen Person aktuell freigegeben sind.",
    empty: "Keine zugewiesenen Kundenakte vorhanden.",
    table: {
      client: "Kund:in",
      caseNumber: "EDV-Nr.",
      status: "Status",
      assignedAt: "Zugewiesen am",
    },
  },
  table: {
    volunteer: "Ehrenamtliche/r",
    kzz: "KZZ",
    phone: "Telefon",
    email: "E-Mail",
  },
  form: {
    username: "Kürzel",
    salutation: "Anrede",
    title: "Titel",
    lastName: "Familienname",
    firstName: "Vorname",
    email: "E-Mail",
    phone: "Telefon",
    remarks: "Bemerkungen",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein (z. B. name@example.at)",
    invalidZipCode: "Die Postleitzahl muss numerisch sein",
    // The Kürzel becomes the Keycloak-Benutzername, so it is restricted to what Keycloak accepts.
    invalidUsername: "Das Kürzel darf nur Buchstaben, Ziffern sowie '.', '_' und '-' enthalten (keine Umlaute).",
    usernameHelper: "Wird als Benutzername für den Portal-Zugang verwendet.",
  },
  // The backend rejects a username that another current volunteer already uses (case-insensitively) —
  // it is the identity link to Keycloak. Without this message the save button would simply do nothing.
  usernameAlreadyTaken: "Dieser Benutzername ist bereits vergeben.",
  // Once portal access exists, the Kürzel is the volunteer's Keycloak login and must stay stable.
  usernameLockedByPortalAccount: "Das Kürzel kann nicht geändert werden, solange die Person Portal-Zugang hat.",
  create: {
    dialogTitle: "Ehrenamtliche/r MitarbeiterIn anlegen",
    successfullyCreated: "Ehrenamtliche/r MitarbeiterIn wurde erfolgreich angelegt.",
    saveFailed: "Ehrenamtliche/r MitarbeiterIn konnte nicht angelegt werden.",
  },
  edit: {
    successfullyUpdated: "Ehrenamtliche/r MitarbeiterIn wurde erfolgreich aktualisiert.",
    successfullyDeleted: "Ehrenamtliche/r MitarbeiterIn wurde erfolgreich gelöscht.",
    saveFailed: "Ehrenamtliche/r MitarbeiterIn konnte nicht aktualisiert werden.",
    deleteFailed: "Ehrenamtliche/r MitarbeiterIn konnte nicht gelöscht werden.",
    deleteConfirmTitle: "MitarbeiterIn löschen?",
    deleteConfirmText: "Soll diese/r MitarbeiterIn wirklich gelöscht werden?",
  },
  // Volunteer-specific (Zugang Ehrenamtliche) sentences of the portal-access UI. Everything
  // subject-neutral lives in `portalAccess`.
  access: {
    title: "Zugang Ehrenamtliche",
    description:
      "Verwalten Sie den Portalzugang der ehrenamtlichen Person. Nach der Freischaltung kann sie sich am externen Portal anmelden.",
    invitation: {
      description: "An die hinterlegte E-Mail-Adresse wird eine Einladungs-E-Mail mit dem Registrierungslink gesendet.",
      emailInfo: "Einladung wird an {{email}} gesendet (aus Persönliche Daten).",
      noEmail:
        "Für die ehrenamtliche Person ist keine E-Mail-Adresse hinterlegt. Ergänzen Sie zuerst eine E-Mail-Adresse in den persönlichen Informationen.",
    },
    pending: {
      description:
        "Die Einladungs-E-Mail wurde versendet. Sobald die ehrenamtliche Person den Registrierungslink öffnet und das Formular ausfüllt, gilt die Registrierung als erfolgreich.",
    },
    manage: {
      confirmLockText:
        "Der Login des Portalbenutzers wird gesperrt. Die Verknüpfung zwischen Benutzer und ehrenamtlicher Person bleibt bestehen.",
      confirmUnlockText:
        "Der Login des Portalbenutzers wird wieder freigegeben. Die ehrenamtliche Person wird per E-Mail informiert.",
      confirmResetText:
        "Die ehrenamtliche Person erhält eine E-Mail an {{email}} mit einem Link zum Setzen eines neuen Passworts.",
    },
  },
};

export default volunteers;
